module.exports = __webpack_public_path__ + "../resources/img/pv_cal_img0.8d21f7b1.png";